/*
 * @Author: czj
 * @Date: 2025-04-17 14:50:45
 * @Description: 
 * @FilePath: \sxtracellular-single-cell\src\locales\language\en.js
 */
export default {
  "name": "China Brain Injury Atlas",
  "greeting": 'Hello, World!',
  "button": {
    "save": 'Save',
    "cancel": 'Cancel'
  },
  "login": {
    "title": "Welcome back!",
    "tip": "Login with your account!",
    "email": "Email",
    "password": "Password",
    "login": " Sign In ",
    "forgot": "Don't have an account?",
    "signup": "Sign Up Now",
    "retrieve": "Forgot password?"
  },
  "topbar": {
    "logout": "log out",
    "signin": "sign in",
  },
  "route": {
    "dataset": "Dataset",
    "analysis": "Analysis",
    "help": "Help",
    "contact": "Contact"
  },
  "home": {
    "dataset": "Dataset",
    "cellnum": "Cell Number",
    "intro": "Intro"
  }
}
